module.exports = __webpack_public_path__ + "static/travel-6732ecaafb1d1b77ed56027836720a64.jpg";